import { render } from "./HelloUser.vue?vue&type=template&id=2fc04430"
import script from "./HelloUser.vue?vue&type=script&lang=js"
export * from "./HelloUser.vue?vue&type=script&lang=js"

import "./HelloUser.vue?vue&type=style&index=0&id=2fc04430&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__